import { Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';

@Directive({
    selector: '[cpqFormFooterAutoSize]',
    standalone: false
})

export class FormFooterAutosizeDirective implements OnInit, OnDestroy {
    private formContainer: Element | null = null;
    private resizeObserver: ResizeObserver | null = null;

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        this.formContainer = document.querySelector('.frame');
        this.setFooterSize();

        if (this.formContainer) {
            this.resizeObserver = new ResizeObserver(() => {
                this.setFooterSize();
            });
            this.resizeObserver.observe(this.formContainer);
        }
    }

    ngOnDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }

    private setFooterSize() {
        if (this.formContainer != null) {
            this.el.nativeElement.style.width = this.formContainer.clientWidth + 'px';
        }
    }
}
